import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';


// fontawesome wrapper
export default class FaIcon extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: null,
  };


  constructor(props) {
    super(props);

    this.defaultPrefixClasses = ['fas', 'fa-fw'];
    this.allowedPrefixClasses = ['fa', 'far', 'fas', 'fal'];
  }

  render() {

    let parts = _.chain(this.props.icon)
      .split(' ')
      .map(_.trim)
      .compact()
      .value();
    let hasPrefix = _.find(parts, v => {
      return _.includes(this.allowedPrefixClasses, v)
    });
    if (!hasPrefix) {
      parts = [].concat(this.defaultPrefixClasses, parts);
    }
    if (this.props.className) {
      parts.unshift(this.props.className);
    }
    parts.unshift('fa-icon');
    let classes = _.join(parts, ' ');

    return (
      <React.Fragment>
        <span className={classes}></span>
      </React.Fragment>
    );
  }
}

